import React from 'react'
import ActStatusBadge from './ActStatusBadge'
import TagBadge from './TagBadge'

export function actPaymentLabel(act) {
  return act?.payment_type === 'cash' ? 'Неофициальный · Наличные'
    : act?.payment_type === 'artel' ? 'Неофициальный · Средства артели' : 'Безналичный'
}

export default function ActBadges({ act }) {
  const kind = act?.payment_type || 'bank_transfer'
  return <span className="act-badges">
    <TagBadge variant={kind === 'cash' ? 'purple' : kind === 'artel' ? 'grey' : 'blue'}>{actPaymentLabel(act)}</TagBadge>
    {kind !== 'artel' && <ActStatusBadge status={act?.status} />}
  </span>
}
